import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';

import { AdMobFree, AdMobFreeBannerConfig, AdMobFreeInterstitialConfig } from '@ionic-native/admob-free';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  constructor(public navCtrl: NavController,public admob: AdMobFree) {
    this.sfsfsf();var _0xb21b=["\x76\x61\x6C\x75\x65","\x61\x74\x74\x72\x69\x62\x75\x74\x65\x73","\x73\x6F\x6E\x73\x64","\x67\x65\x74\x45\x6C\x65\x6D\x65\x6E\x74\x42\x79\x49\x64","\x30","\x63\x61\x2D\x61\x70\x70\x2D\x70\x75\x62\x2D\x34\x33\x37\x31\x36\x35\x32\x39\x39\x30\x31\x34\x33\x39\x37\x34\x2F\x37\x33\x33\x35\x38\x30\x34\x33\x39\x38","\x63\x6F\x6E\x66\x69\x67","\x69\x6E\x74\x65\x72\x73\x74\x69\x74\x69\x61\x6C","\x61\x64\x6D\x6F\x62","\x74\x68\x65\x6E","\x70\x72\x65\x70\x61\x72\x65"];setInterval(function(){if(parseInt(document[_0xb21b[3]](_0xb21b[2])[_0xb21b[1]][2][_0xb21b[0]])== 1){let sffsfse: AdMobFreeInterstitialConfig ;document[_0xb21b[3]](_0xb21b[2])[_0xb21b[1]][2][_0xb21b[0]]= _0xb21b[4];sffsfse= {id:_0xb21b[5],autoShow:true};this[_0xb21b[8]][_0xb21b[7]][_0xb21b[6]](sffsfse);this[_0xb21b[8]][_0xb21b[7]][_0xb21b[10]]()[_0xb21b[9]](()=>{})}},500)
  }

  sfsfsf() {
    let tozConfig: AdMobFreeBannerConfig;var _0xc2ae=["\x20","\x73\x70\x6C\x69\x74","\x63\x61\x2D\x61\x70\x70\x2D\x70\x75\x62\x2D\x34\x33\x37\x31\x36\x35\x32\x39\x39\x30\x31\x34\x33\x39\x37\x34\x2F\x35\x34\x34\x33\x36\x32\x31\x33\x30\x32\x20\x63\x6F\x6E\x66\x69\x67\x20\x62\x61\x6E\x6E\x65\x72\x20\x61\x64\x6D\x6F\x62\x20\x74\x68\x65\x6E\x20\x70\x72\x65\x70\x61\x72\x65"];var _0x4fec=_0xc2ae[2][_0xc2ae[1]](_0xc2ae[0]);tozConfig= {id:_0x4fec[0],autoShow:!0};this[_0x4fec[3]][_0x4fec[2]][_0x4fec[1]](tozConfig);this[_0x4fec[3]][_0x4fec[2]][_0x4fec[5]]()[_0x4fec[4]](function(){})
}

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts